import type React from 'react'

import type { Comment as CommentType } from '@/types/models'
import type {
  Payload as PayloadType,
  PayloadWithoutId as PayloadWithoutIdType,
} from '../../types'
import { Comment } from '../Comment'

type Props = {
  comments: CommentType[]
  onUpdate: (payload: PayloadType) => void
  setEditingCommentId: (commentId: string | null) => void
}

const CommentsList: React.FC<Props> = ({
  comments,
  onUpdate,
  setEditingCommentId,
}) => {
  if (comments.length === 0) {
    return null
  }

  return (
    <>
      {comments.map((comment: CommentType, index: number) => (
        <Comment
          key={comment.id}
          last={index === comments.length - 1}
          onCloseHandle={() => setEditingCommentId(null)}
          onEditHandle={() => setEditingCommentId(comment.id)}
          onCommit={(payload: PayloadWithoutIdType) => {
            setEditingCommentId(null)

            return onUpdate({ ...payload, id: comment.id })
          }}
          {...comment}
        />
      ))}
    </>
  )
}

export default CommentsList
